<template>
  <div class="campaign-view-page mt-4">
    <app-page-header title="Campanhas"></app-page-header>

    <div class="container campaign-container">
      <div class="row">
        <div class="col-md-6 campaign-left">
          <img :src="campaign.image" alt />
        </div>
        <div class="col-md-6">
          <h1>{{ campaign.name }}</h1>
          <p v-html="campaign.text"></p>
          <div class="campaign-duration">
            <strong>Vigência:</strong>
            <span
              >{{ campaign.start_at | date }} a
              {{ campaign.end_at | date }}</span
            >
          </div>

          <div class="campaign-points-table">
            <h2>Pontos por produto nesta campanha</h2>
            <b-table
              :data="campaignPoints"
              :loading="isLoading"
              paginated
              backend-pagination
              :total="total"
              :per-page="perPage"
              @page-change="onPageChange"
              aria-next-label="Próxima Página"
              aria-previous-label="Página Anterior"
              aria-page-label="Página"
              aria-current-label="Página Atual"
            >
              <template slot-scope="props">
                <b-table-column
                  field="points"
                  label="Pontos"
                  class="points"
                  numeric
                  >{{ props.row.points | number }}</b-table-column
                >

                <b-table-column field="name" label="Produto">{{
                  props.row.product.name
                }}</b-table-column>
              </template>

              <template slot="empty">
                <section class="section">
                  <div class="content has-text-grey has-text-centered">
                    <p>
                      <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                    </p>
                    <p>Nenhum registro encontrado.</p>
                  </div>
                </section>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>

    <div class="container campaign-points-container"></div>
  </div>
</template>

<script>
import CampaignService from '@/services/campaign.service';
import CampaignPointsService from '@/services/campaign-points.service';

export default {
  name: 'campaign-view-page',
  data: () => {
    return {
      isLoading: true,
      campaign: {},
      campaignPoints: [],
      total: null,
      page: 1,
      perPage: 10,
    };
  },
  methods: {
    loadCampaign(id) {
      CampaignService.getId(id).then(({ data }) => {
        this.campaign = data;
      });
    },
    loadCampaignPoints(id) {
      CampaignPointsService.getByCampaign(id, {
        page: this.page,
        perPage: this.perPage,
      })
        .then(({ data }) => {
          this.campaignPoints = data.data;
          this.total = data.total;
        })
        .finally(() => (this.isLoading = false));
    },
    onPageChange(page) {
      this.page = page;
      this.loadCampaignPoints(this.campaign.id);
    },
  },
  beforeMount() {
    const id = this.$route.params.id;
    if (id) {
      this.loadCampaign(id);
      this.loadCampaignPoints(id);
    }
  },
};
</script>

<style lang="scss" scoped>
.campaign-container {
  .campaign-left {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;

    img {
      margin-right: 3em;
    }
  }

  h1 {
    color: var(--color-primary);
    font-size: 2em;
    font-weight: bold;
  }

  h2 {
    font-size: 1.3em;
    font-weight: bold;
    text-align: center;
    margin-bottom: 0.5em;
  }

  p {
    margin-top: 2em;
    font-size: 1em;
    line-height: 2em;
  }

  .campaign-duration {
    margin-top: 2em;
    font-size: 1.1em;

    strong {
      margin-right: 10px;
      font-weight: bold;
    }
  }

  .campaign-points-table {
    margin-top: 4em;
  }

  .points {
    color: var(--color-primary);
    font-weight: bold;
    font-size: 1.2em;
    text-align: center;
  }
}

@media (max-width: 992px) {
  .campaign-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .campaign-left {
      display: block;
    }

    .campaign-points-table {
      margin-top: 2em;
    }
  }
}
</style>
